export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70e6947b5e5358c0a3289a22b53799d0f6ab5c2ae1&name=pushAdClickData!'